document.addEventListener("DOMContentLoaded", function () {
  const chatLink = document.querySelectorAll(".chat--link");
  if (chatLink.length) {
    chatLink.forEach((ele)=>{
      ele.addEventListener("click", function(e){
        const chatDialog = document.querySelector('#shopify-chat inbox-online-store-chat');
        if(chatDialog){
          e.preventDefault();
          chatDialog?.shadowRoot.querySelector('button')?.dispatchEvent(new Event('click')); 
        }
      });
    })
  }
});